import { ItemList } from 'orm'

class UserNotificationList extends ItemList {
  getEntityKey() {
    return "admin/notification"
  }
}

export const adminUserNotificationList = new UserNotificationList( "admin_user_notification__default" )
